import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {app} from './firebase'
import 'highlight.js/styles/github-dark-dimmed.css'
import 'highlight.js/lib/common';
import hljsVuePlugin from "@highlightjs/vue-plugin";
import VueGtag from 'vue-gtag';

createApp(App).use(store).use(hljsVuePlugin).use(app).use(router).use(VueGtag, {id: "G-31KR96FGMP" }, router).mount('#app')
